export default __webpack_public_path__ + "static/media/role-play.0e39bcca.svg";